module.exports = __webpack_public_path__ + "img/car_scrappage3.5cc6c96e.jpeg";